import { RuleProps } from 'types/application';

export const TWCCL_INSTALLER_DETAILS = 'contractor-installer-details';
export const TWCCL_INITIAL_DETAILS = 'twccl-initial-details';
export const TWCCL_END_DETAILS = 'twccl-end-details';

export const TWCCL_LICENCE = [
    {
        sectionID: TWCCL_INITIAL_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'service-provided',
                label: 'Service Provided',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: TWCCL_INSTALLER_DETAILS,
        sectionName: 'Wiring Installer Information',
        fieldList: [
            {
                id: 'contractor-installer-details',
                label: '',
                type: 'table2',
                subFields: [
                    {
                        id: 'wiring-installer-no',
                        header: 'Wiring Installer No',
                        type: 'text'
                    },
                    {
                        id: 'wiring-installer-name',
                        header: 'Wiring Installer Name',
                        type: 'text'
                    },
                    {
                        id: 'status',
                        header: 'Status',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    {
        sectionID: TWCCL_END_DETAILS,
        sectionName: 'Supporting Documents',
        rule: {
            baseIds: [`${TWCCL_END_DETAILS}-proof-of-certificate`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${TWCCL_END_DETAILS}-proof-of-certificate`] === '-');
                return result;
            }
        },
        fieldList: [
            {
                id: 'proof-of-certificate',
                label: 'Proof Of Certificate',
                type: 'text',
                span: 12
            }
        ]
    }
];
